module.exports = __webpack_public_path__ + "img/63.fdc78918.webp";